<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useEditTransaction } from "@/components/EditTransaction/state.ts";

import DatePicker from "@/components/DateRange/DatePicker.vue";

const state = useEditTransaction();

const { date } = storeToRefs(state);
</script>

<template>
  <div class="sm:grid sm:grid-cols-1 sm:items-start sm:gap-4 sm:py-06">
    <label class="block text-sm/6 font-medium text-gray-900" for="date">Datum</label>
    <div class="sm:col-span-2">
      <DatePicker :current-date="date" @changed="date = $event"></DatePicker>
    </div>
  </div>
</template>
